import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import ReactWhatsapp from "react-whatsapp";


import rooftopgarden from "../images/rooftop garden and.jpg";
import RoofTop from "../images/rooftop garden and lane.jpg";
import lane from "../images/rooftop garden and lane design.jpg";
import rooftopnew from "../images/rooftop garden and lane 4.jpg";






import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'




import Header from "../inc/Header";

function RoofGarden() {
  return (
    <div>

      <Header />
      <br />
      <br />
      <br />
      <br />
      <ScrollToTop smooth top="100" color="maroon" />
      <div className='exteriordesign'>
        <div className="album py-1">
          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Roof Top Garden & Lane </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className='az2service'>
        <div className="album py-0">
          <div className="container">
            <div className="row">

              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>

                          <img src={rooftopgarden} className="card-img-top" alt="rooftopgarden"/>

                        </Zoom>
                        <div className="card-body">
                          <h5 style={{ color: "black" }} className="card-title mb-2">Roof Top Garden & Lane </h5>
                         

                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={RoofTop} className="card-img-top" alt="RoofTop"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 style={{ color: "black" }} className="card-title mb-2">Roof Top Garden & Lane</h5>
                        
                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={lane} className="card-img-top" alt="lane"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 className="card-title mb-2">Roof Top Garden & Lane </h5>
               
                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={rooftopnew} className="card-img-top" alt="rooftopnew"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 className="card-title mb-2" >Roof Top Garden & Lane                              </h5>
                      
                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

    

  <br />

      <br />


      </div>
    
    </div>
  )
}

export default RoofGarden